// @ts-check
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Message } from '../../ui'
import { useStore } from '../../StateProvider'
import { getTextByLang } from '../ExternalFields'

const DisabledMessage = () => {
  const { t } = useTranslation()
  const [
    {
      whitelabel: {
        customTexts,
        whiteLabelName
      }
    }
  ] = useStore()

  const copyright = getTextByLang('copyright', customTexts) || whiteLabelName

  return (
    <Message title='' type='failed'>
      {t('createAccount.disabledMessage1', { copyright })}
      <br />
      {t('createAccount.disabledMessage2')}
      <br />
      {t('createAccount.disabledMessageIfYouHave')}
      <a href='https://share.hsforms.com/12L7GLggaTuOTMo6JZxThMw4r2p5'>
        {t('createAccount.disabledMessageForm')}
      </a>{' '}
      {t('createAccount.disabledMessageContact')}
    </Message>
  )
}
export { DisabledMessage }
